import BaseView from '../core/baseView';
import * as lightbox from '../../home24/helpers/lightbox';

export default BaseView.extend({
  initialize: function() {
    if (this.$el.length > 0) {
      lightbox
        .setConfig({
          $dialog: this.$el,
          className: 'alternative-country-box'
        })
        .open();
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/alternativeCountryView.js
 **/